// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__fVfEx","logout":"Dropdown_logout__o4KgH","logoutIcon":"Dropdown_logoutIcon__2o7zm","button":"Dropdown_button__24a8T"};